import React from 'react'
import {Dropdown, Input, Table} from 'semantic-ui-react'
import Single from '../../../componentes/Single'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import DateUtilities from '../../../componentes/DateUtilities'
import SubmitButton from '../../../componentes/submitButton/submitButton'
import {PositiveNumInput as InputNum} from '../../../componentes/PositiveNumInput/PositiveNumInput'

class Compra extends React.Component {
    constructor(props) {
        super(props)
        this.database = firebase.firestore()
        this.state = {
            compra: {
                presentacion: '',
                proveedor: '',
                precio: 0,
                cantidad: 0,
                total: 0,
                unidades:'',
                tipo: 'producto'
            },
            message: '',
            almacen: ''
        }
    }
    componentDidMount() {
        const firestore = firebase.firestore();
        const docRef = firestore.collection('Info').doc('info');

        docRef.get().then((doc) => {
        if (doc.exists) {
            this.setState({ almacen: doc.data().almPrincipal });
        } else {
            console.log('No such document!');
        }
        }).catch((error) => {
        console.log('Error getting document:', error);
        });
    }
    handleChange = async(e, { name, value }) => {
        const compra = { ...this.state.compra }
        if(name==='presentacion'){
            const presentacion=(await firebase.firestore().collection('Presentacion').where('clave', '==', value).get()).docs[0]
            compra.producto=presentacion.data().producto
            compra.contenido=presentacion.data().contenido
            compra.unidades=presentacion.data().unidades
        }
        compra[name] = value
        compra.total = compra.precio * compra.cantidad
        this.setState({ compra: compra })
    }
    handleSubmit = async () => {
        if (
            this.state.compra.presentacion === '' ||
            this.state.compra.proveedor === '' ||
            this.state.compra.precio === 0 ||
            this.state.compra.cantidad === 0
        ) {
            this.setState({ message: 'Llene todos los campos' })
            return null
        }
        const compra = { ...this.state.compra }
        compra.fecha = new Date();
        compra.cantidad = parseFloat(compra.cantidad)
        const batch = firebase.firestore().batch()
        const compras = firebase.firestore().collection('Compras')
        const inventario = firebase.firestore().collection('Inventario')
        try {
            const snap = await inventario.where('nombre', '==', compra.producto).where('ubicacion', '==', this.state.almacen).get()
            batch.set(compras.doc(), compra)
            if(snap.docs.length>0){
                const idProduct = snap.docs[0].id
                batch.update(inventario.doc(idProduct), { enInventario: snap.docs[0].data().enInventario + +(compra.contenido * compra.cantidad).toFixed(2) })
            }
            else{
                batch.set(inventario.doc(), {
                    enInventario:+(compra.contenido * compra.cantidad).toFixed(2),
                    nombre:compra.producto,
                    ubicacion:this.state.almacen,
                    unidades:compra.unidades,
                })
            }
            batch.commit().then(() => {
                this.setState({
                    message: 'Compra  agregada con éxito',
                    compra: {
                        presentacion: '',
                        proveedor: '',
                        precio: 0,
                        cantidad: 0,
                        total: 0,
                        unidades:'',
                    }
                })
            })
        }
        catch (e) {
            console.log(e)
            this.setState({
                message: 'Ocurrió un error!',
            })
        }
    }
    render() {
        return (
            <section>
                <h3>Nueva Compra</h3>
                <div>
                    <Single placeholder='Presentacion' search tabla='Presentacion' columna='clave' onChange={this.handleChange} name='presentacion' value={this.state.compra.presentacion} />
                    <Single placeholder='Proveedor' search tabla='Proveedores' columna='nombre' onChange={this.handleChange} name='proveedor' value={this.state.compra.proveedor} />
                    <InputNum label='Cantidad' type='number' onChange={this.handleChange} value={this.state.compra.cantidad} name='cantidad' />
                    <InputNum label='Precio Unitario' type='number' onChange={this.handleChange} value={this.state.compra.precio} name='precio' />
                    <InputNum label='Total' type='number' value={this.state.compra.total} name='total' disabled />
                    <SubmitButton handleSubmit={this.handleSubmit}>Enviar</SubmitButton>
                </div>
                <p>{this.state.message}</p>
                <TablaCompras />
            </section>
        )
    }
}

class TablaCompras extends React.Component {
    constructor(props) {
        super(props)
        this.database = firebase.firestore()
        this.state = {
            dateFilter:'mes',
            firstDate:'',
            firstDateStr:'',
            secondDate:'',
            secondDateStr:'',
            rows: [],
            sector:"",
        }
    }
    componentDidMount() {
        this.listCompras()
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.secondDate !== prevState.secondDate || this.state.firstDate !== prevState.firstDate) {
            if (this.state.firstDate !== "" && this.state.secondDate !==""){
                this.unsubscribe()
                this.listCompras()
            }
        }
    }
    setReference=()=>{
        let dbReference=firebase.firestore().collection('Compras')
        dbReference=this.filterByDate(dbReference)
        return dbReference
    }
    listCompras = () => {
        this.unsubscribe=this.setReference().orderBy('fecha', 'desc')
            .onSnapshot(snap => {
                const rows = []
                for (let i = 0; i < snap.docs.length; i++) {
                    rows.push(snap.docs[i].data())
                }
                this.setState({
                    rows: rows
                })
            })
    }
    handleSpecificDateChange=(e, {name, value})=>{
        const date=DateUtilities.parseDate(value)
        this.setState({
            [name]:date,
            [name+'Str']:value
        })
    }
    filterByDate=(dbReference)=>{
        if(this.state.dateFilter==='specificDateRange'){
            if(this.state.firstDate!=='' && this.state.secondDate!==''){
                return this.filterSpecificDates(dbReference)
            }
        }
        if(this.state.dateFilter==='mes'){
            return this.filterEsteMes(dbReference)
        }
        return dbReference
    }
    filterEsteMes=dbReference=>{
        let first = DateUtilities.getFirstDayOfMonth()
        return dbReference.where('fecha', '>=', first)
    }
    filterSpecificDates=dbReference=>{
        return dbReference.where('fecha', '>=', this.state.firstDate).where('fecha', '<=', DateUtilities.addDays(this.state.secondDate, 1))
    }
    handleDateFilterChange=(e, {value})=>{
        this.setState({dateFilter:value})
    }
    render() {
        return (
            <section>
                <div><h3>Historial</h3>
                    <div className="filtros">
                        <div>
                            <Dropdown
                                fluid
                                selection
                                options={[
                                    {key:1, text:'Este Mes', value:'mes'},
                                    {key:2, text:'Fechas específicas', value:'specificDateRange'},
                                ]}
                                name='dateFilter'
                                value={this.state.dateFilter}
                                onChange={this.handleDateFilterChange}
                            />
                        </div>
                        {
                            this.state.dateFilter==='specificDateRange'
                                ?
                            <>
                            <div>
                                <h3>Del</h3>
                                <Input
                                    type='date'
                                    value={this.state.firstDateStr}
                                    name='firstDate'
                                    onChange={this.handleSpecificDateChange}
                                />
                            </div>
                            <div>
                                <h3>Al</h3>
                                <Input
                                    type='date'
                                    value={this.state.secondDateStr}
                                    name='secondDate'
                                    onChange={this.handleSpecificDateChange}
                                />
                            </div>
                            </>
                            :null
                        }
                    </div>
                </div>
                <div  className="body tabla">
                    <table><tbody>
                        <tr>
                            <th>Producto</th>
                            <th>Presentacion</th>
                            <th>Proveedor</th>
                            <th>Cantidad</th>
                            <th>Precio</th>
                            <th>Total</th>
                            <th>Fecha</th>
                        </tr>
                        {this.state.rows.map((row, i) => {
                            return (
                                <Table.Row key={i}>
                                    <Table.Cell>{row.producto}</Table.Cell>
                                    <Table.Cell>{row.presentacion}</Table.Cell>
                                    <Table.Cell>{row.proveedor}</Table.Cell>
                                    <Table.Cell>{`${row.cantidad} unidades`}</Table.Cell>
                                    <Table.Cell>{row.precio}</Table.Cell>
                                    <Table.Cell>{row.total}</Table.Cell>
                                    <Table.Cell>{row.fecha.toDate().toLocaleDateString()}</Table.Cell>
                                </Table.Row>
                            )
                        })}
                    </tbody></table>
                </div>
            </section>
        )
    }
}

export default Compra